import { AdvancedSearch, Facet, RangeBucket, StructuredQuery } from '../../core/query/entities/structured-query.entity';
import { dateRangeStringToRangeValue } from './convert-structured-query.helper';
import { IsLaxDateRangeQuery } from '../../core/dates/helpers/date-range-query-helper';

export function FixStructuredQuery(structuredQuery: StructuredQuery): StructuredQuery {
    return {
        ...structuredQuery,
        AdvancedSearch: FixAdvancedSearch(structuredQuery.AdvancedSearch),
        Facets: FixFacets(structuredQuery.Facets)
    };
}

function FixAdvancedSearch(advancedSearch: AdvancedSearch): AdvancedSearch {
    for (const group of advancedSearch.Groups) {
        if (!group.Terms) {
            continue;
        }

        for (const term of group.Terms) {
            if (!term.Values?.length) {
                continue;
            }

            const isDate: boolean = IsLaxDateRangeQuery(term.Values[0]);

            if (!isDate) {
                continue;
            }
            term.RangeValues = [dateRangeStringToRangeValue(term.Values[0])];
            delete term.Values;
        }
    }
    return advancedSearch;
}

function FixFacets(facets: Facet[]): Facet[] {
    for (const facet of facets) {
        if (!facet.Buckets) {
            continue;
        }

        for (let i: number = facet.Buckets.length - 1; i >= 0; i--) {
            const bucket = facet.Buckets[i];
            const isDate: boolean = IsLaxDateRangeQuery(bucket.Value);

            if (!isDate) {
                continue;
            }

            if (!facet.RangeBuckets) {
                facet.RangeBuckets = [];
            }

            const rangeBucket: RangeBucket = {
                Operand: bucket.Operand,
                RangeValue: dateRangeStringToRangeValue(bucket.Value)
            };

            facet.RangeBuckets.push(rangeBucket);
            facet.Buckets.splice(i, 1);
        }

        if (facet.Buckets.length === 0) {
            delete facet.Buckets;
        }
    }
    return facets;
}
